export type EngagementOverviewTabId =
  | "all-campaigns"
  | "email-campaigns"
  | "whatsapp-campaigns";

export type EngagementOverviewTabItem = {
  id: EngagementOverviewTabId;
  labelKey: string;
};

export const ENGAGEMENT_OVERVIEW_TAB_ITEMS: EngagementOverviewTabItem[] = [
  { id: "all-campaigns", labelKey: "engagementOverview.tabs.all" },
  { id: "email-campaigns", labelKey: "engagementOverview.tabs.email" },
  { id: "whatsapp-campaigns", labelKey: "engagementOverview.tabs.whatsapp" },
];
